export interface ClockIconProps {
  size?: number;
}

const ClockIcon = ({ size = 12 }: ClockIconProps) => (
  <svg
    aria-hidden
    fill='none'
    height={size}
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    viewBox='0 0 24 24'
    width={size}
  >
    <circle cx='12' cy='12' r='9' />
    <path d='M12 7v5l3 2' />
  </svg>
);

export default ClockIcon;
